import { forwardRef } from "react";

import Icon from "@/components/Icon";
import ChallengesActivityRawIcon from "./ChallengesActivityRawIcon.svg.jsx";

const ChallengesActivityIcon = forwardRef((props, ref) => {
  return (
    <Icon
      ref={ref}
      SvgComponent={ChallengesActivityRawIcon}
      data-testid="challenges-activity-icon"
      {...props}
    />
  );
});

export default ChallengesActivityIcon;
